// The request form's date-selection cap. The agents-API request.set_dates
// play enforces the same number so a support-side date fix can never build
// a window the customer couldn't have picked themselves.
export const MAX_SELECTABLE_DATES = 28;
